var _defs, _path, _path2, _ellipse, _ellipse2, _rect, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _path6, _path7, _path8, _rect6, _rect7, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect8, _rect9, _rect10, _rect11, _path16, _circle, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect12, _rect13, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "General",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.92 540.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{fill:#c9e1ff;}.cls-2{fill:#006aea;}.cls-3{fill:#ce9986;}.cls-4{fill:#75b2fc;}.cls-5{fill:#00479b;}.cls-6{fill:#fff;}.cls-7{fill:#95c3fa;}.cls-8{fill:#dcedff;}.cls-9{stroke:#2976ff;}.cls-10,.cls-9{stroke-miterlimit:10;}.cls-10{fill:none;stroke:#237af9;stroke-width:5px;}.cls-11{fill:#237af9;}.cls-12{fill:#aed3ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.69,1045.83a16,16,0,0,0,.49-3.93c0-10.71-10.56-19.39-23.6-19.39l-.79,0c-3.25-11.87-16.14-20.74-31.57-20.74-10.76,0-20.28,4.32-26.17,11a26,26,0,0,0-17.64-6.52c-13,0-23.59,8.68-23.59,19.39a16.41,16.41,0,0,0,.65,4.55c-.75-.05-1.52-.08-2.29-.08-16.73,0-30.28,11.15-30.28,24.89,0,13.53,13.12,24.52,29.48,24.88,2.37,2.56,19.1,20,44.66,18.56a56.2,56.2,0,0,0,33-13.58c13.21,9.63,29.51,11.7,41.87,4.94,7.43-4,19-14.35,17.08-27.39C355.59,1053,347.9,1047.34,345.69,1045.83Zm-83.33-3.93h-3.13a22.7,22.7,0,0,0,2.23-1.34C261.74,1041,262,1041.47,262.36,1041.9Z",
    transform: "translate(-190.9 -558.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.24,1018.52a25.92,25.92,0,0,0,.54-4.2c.49-11.48-6.78-21.11-16.25-21.52H412c-1.82-12.82-10.77-22.74-22-23.22-7.82-.34-15,4-19.53,10.92-17.47-6.79-34.26,7.38-37,25.12-2,13.12,3.65,28,14.29,35.89q10.49.2,21.58.93c11,.74,21.52,1.86,31.57,3.27,19.06,3.4,32.85-.8,34.81-9.08C436,1035.39,437.15,1029.26,428.24,1018.52Zm-60.38-6.83-2.28-.1a16.75,16.75,0,0,0,1.68-1.37Q367.54,1011,367.86,1011.69Z",
    transform: "translate(-190.9 -558.44)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 73.6,
    cy: 105.7,
    rx: 52.24,
    ry: 50.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 76.53,
    cy: 108.85,
    rx: 52.24,
    ry: 50.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 411.41,
    y: 557.58,
    width: 136.8,
    height: 202.01,
    rx: 17.73,
    transform: "translate(-369.67 579.96) rotate(-90)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.19,708.28c-.27-3.61.83-5,0-8.61a14.83,14.83,0,0,0-2.72-5.89,15,15,0,0,0-12.23-5.43c-4.36.18-7.33,2.31-10.42,4.53-2.66,1.91-5.08,3.65-6.34,6.79-1.11,2.79-.23,4-.45,9.51,0,.8-.08,1.51-.14,2.14-.27-1.46-.93-2.49-1.8-2.6-1.39-.17-2.79,2-3.15,4.82s.48,5.27,1.87,5.44c.68.09,1.36-.4,1.93-1.25a5.59,5.59,0,0,0,.08,1.38c1,6.15,9.27,11.92,17.49,12.11,9.74.23,19.07-7.39,19.05-13.43C340.34,714.51,337.58,713.7,337.19,708.28Z",
    transform: "translate(-190.9 -558.44)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M385.69,828.93A41,41,0,0,1,394.45,845l3.09,23.18c.38,5.44.76,13.45.52,23.18-.18,7.31-.5,7.91-1.55,23.18-1.48,21.61-1,22.45-2.58,24.81-8.92,13-41.09,11.72-47.17,0-2-3.82-1.67-9.65-1.35-16,.17-3.18.27-4.07,1.62-11.82,1.8-10.4,3.91-16.71,1-22.58-2.26-4.6-6.52-6.79-9.8-7.92l-10.82,2.57c-6.24,33.18-5.62,58.62-3.72,76.22,1.29,12,3.88,26.84-4.68,34.56-7.15,6.44-19.44,5.54-26.28,5-5.89-.43-15.71-1.15-21.6-6.12-12.94-10.91-4.3-40,.36-59.76,6-25.37,11.67-61.78,9.73-109.43h35.59a252.91,252.91,0,0,1,40.52-4.63q7.15-.24,13.89-.08A33.35,33.35,0,0,1,385.69,828.93Z",
    transform: "translate(-190.9 -558.44)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.77,860.18c3.82-3.95,15.08-2,19.2,5.29,3.76,6.62.91,15.83-5.29,19.2-4.74,2.57-11.71,1.87-14-1.57-1.45-2.16,0-3.8.2-10.68C257.1,864.17,255,862,256.77,860.18Z",
    transform: "translate(-190.9 -558.44)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 260.64,
    y: 879.75,
    width: 7.51,
    height: 23.47,
    rx: 2.64,
    transform: "translate(-233.61 1210.74) rotate(-144.2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 264.73,
    y: 879.46,
    width: 6.78,
    height: 19.4,
    rx: 2.38,
    transform: "translate(74.63 1259.42) rotate(-163.06)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 254.71,
    y: 880.43,
    width: 7.51,
    height: 14.11,
    rx: 2.64,
    transform: "translate(-323.24 1166.72) rotate(-138.75)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 253.69,
    y: 876.72,
    width: 7.51,
    height: 9.62,
    rx: 2.64,
    transform: "translate(-321.1 1155.62) rotate(-138.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M416.1,750.93a40.07,40.07,0,0,1-6.7,11.41,38.12,38.12,0,0,1-14.95,10.88A30.64,30.64,0,0,1,382.08,770a34.11,34.11,0,0,1-14.95-15.76,70,70,0,0,0-10.83-7.61,68,68,0,0,0-13.91-6l-18.05-2.88a126.64,126.64,0,0,0-20.1-.38,83.68,83.68,0,0,0-16,2.17c-5,1.23-9.45,2.31-14.47,5.44-3.47,2.16-5.79,4.55-10.27,9.24A176.68,176.68,0,0,0,250.11,770c-5.41,7.25-9,12.07-12.37,19a80.16,80.16,0,0,0-7.22,23.37c-3.3,26.06,16.31,49,19.59,52.73l29.6-11.4c-3.73-6.13-17.16-29.1-12.68-42.24.7-2.07,1.93-4.12,4.22-10.5,2.73-7.61,3.37-11.34,6.7-13.59a10.38,10.38,0,0,1,6.19-1.63l-2.89,39.64h71.18V786.81q2.71,4.89,5.42,9.78A40.5,40.5,0,0,0,370,807.69a38.42,38.42,0,0,0,10,4.12,37,37,0,0,0,10.82,0,38.38,38.38,0,0,0,15.47-6,67.21,67.21,0,0,0,17-13.59,70.8,70.8,0,0,0,10.39-15.06Z",
    transform: "translate(-190.9 -558.44)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.52,691.09a8.62,8.62,0,0,1-2,5.42,9.24,9.24,0,0,1-5.42,2.71c-7.95,1.6-11.92.28-16.31,1.21-3.12.65-7.37,2.64-11.77,8.75a13.2,13.2,0,0,1-1.51-10.26,12.62,12.62,0,0,1,4.22-6.29,17.14,17.14,0,0,1,6.05-4.28,19.15,19.15,0,0,1,8.15-1.21,37.28,37.28,0,0,0,15.89-3.79,14.4,14.4,0,0,1,1.62,2.88A14.25,14.25,0,0,1,340.52,691.09Z",
    transform: "translate(-190.9 -558.44)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.81,698.25l-1.2-21.19,4.14-18.4A12.26,12.26,0,0,0,264.48,644l-51.86-11.69A12.27,12.27,0,0,0,198,641.58L193.12,663a12.26,12.26,0,0,0,9.27,14.66l44.13,9.95,22.89,11.53A1,1,0,0,0,270.81,698.25Z",
    transform: "translate(-190.9 -558.44)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 211.67,
    y: 650.11,
    width: 50.1,
    height: 6.65,
    transform: "translate(-61.03 -591.73) rotate(11.07)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 208.85,
    y: 664.05,
    width: 50.1,
    height: 3.32,
    transform: "translate(-58.72 -590.96) rotate(11.07)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.37,782.63a10.82,10.82,0,0,1-7.06,4c-5.44.6-9-3.57-9.25-3.93l.06-16.62,16.31-.06Z",
    transform: "translate(-190.9 -558.44)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M456.44,1032.28a6.54,6.54,0,0,0,.2-1.59c0-4.32-4.27-7.83-9.52-7.83h-.33c-1.31-4.79-6.51-8.37-12.73-8.37a14.08,14.08,0,0,0-10.56,4.43,10.48,10.48,0,0,0-7.12-2.64c-5.26,0-9.53,3.51-9.53,7.83a6.66,6.66,0,0,0,.27,1.84c-.31,0-.61,0-.93,0-6.75,0-12.22,4.5-12.22,10s5.3,9.89,11.9,10a10.48,10.48,0,0,0,4,.77h32.29a10.41,10.41,0,0,0,4.58-1,11.09,11.09,0,0,0,4.74,1c5.26,0,9.52-3.5,9.52-7.82A7.64,7.64,0,0,0,456.44,1032.28Zm-33.63-1.59h-1.26q.46-.26.9-.54Q422.62,1030.42,422.81,1030.69Z",
    transform: "translate(-190.9 -558.44)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.53,981.66l-31-.19a124.61,124.61,0,0,0,.68-14.15c-.09-9-1.09-11.2.78-13.29,3.28-3.69,8.86.47,20.17-2.19,7.06-1.66,10.2-4.53,11.8-3.08,1.89,1.74-1.63,6.7-3.17,14.35A40.21,40.21,0,0,0,392.53,981.66Z",
    transform: "translate(-190.9 -558.44)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.12,993.42c-1.28,5.18-18.54,5.38-28.22,4.66-15.59-1.15-17.85-3.83-18.49-5-1.17-2.07-.58-3.79.08-11.66.46-5.52.62-10,.68-12.77a274.41,274.41,0,0,1,30.55,9.52c2.7,1,5.34,2.06,7.95,3.13a24.11,24.11,0,0,1,5,5.87C407.49,990.29,408.48,991.94,408.12,993.42Z",
    transform: "translate(-190.9 -558.44)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.16,1036l-32.38-.78a52.63,52.63,0,0,0,.37-19.54c-.93-5.22-2.44-8.63-.54-10.69,1.74-1.87,4.54-.71,12.48-.09,12.24,1,16.11-1,18.85,2.09,1.39,1.55,1.5,3.26,1.51,9.44C310.46,1021.68,310.4,1028.3,310.16,1036Z",
    transform: "translate(-190.9 -558.44)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.72,1048.68c-1.39,3.13-9.67,1.31-24.77,1.15-15.28-.16-21.45,1.55-23.94-2.33-.86-1.34-.79-2.6.2-10.5.74-5.81,1.44-11,2.05-15.25,16.35,6.54,25.87,9.59,31.31,10.61a17.64,17.64,0,0,1,8.09,3.45,19.27,19.27,0,0,1,4.85,6.29C325.38,1045.59,326.31,1047.34,325.72,1048.68Z",
    transform: "translate(-190.9 -558.44)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M286.92,1045.1a14.59,14.59,0,0,0,.3-2.31c.27-6.32-3.73-11.63-9-11.85H278c-1-7.06-5.92-12.51-12.09-12.78-4.31-.18-8.23,2.2-10.75,6-9.62-3.74-18.86,4.06-20.37,13.82-1.12,7.22,2,15.41,7.87,19.75q5.77.1,11.88.51c6,.41,11.84,1,17.37,1.8,10.49,1.88,18.08-.44,19.16-5C291.18,1054.38,291.83,1051,286.92,1045.1Zm-33.23-3.76-1.26-.06a10.9,10.9,0,0,0,.93-.75Q253.51,1040.94,253.69,1041.34Z",
    transform: "translate(-190.9 -558.44)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 391.84,
    y: 549.13,
    width: 15.78,
    height: 34.4,
    rx: 6.43,
    transform: "translate(-357.49 407.62) rotate(-90)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 519.47,
    y: 671.03,
    width: 78.17,
    height: 78.17,
    rx: 9.49,
    transform: "translate(-342.46 710.22) rotate(-90)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 492.14,
    y: 585.01,
    width: 47.41,
    height: 88.81,
    rx: 5.43,
    transform: "translate(-304.47 586.83) rotate(-90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 430.18,
    y: 641.35,
    width: 38.33,
    height: 105.24,
    rx: 5.43,
    transform: "translate(-435.52 584.88) rotate(-90)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451,737.58a3.09,3.09,0,0,0-2.46-3.62l-1.3-.25a3.08,3.08,0,0,0-2.29.46l0-.08a3.09,3.09,0,0,0-2.46-3.61l-1.3-.25a3.09,3.09,0,0,0-3.19,1.37l1.47-15.48a3.09,3.09,0,0,0-2.79-3.37l-1.32-.13a3.09,3.09,0,0,0-3.37,2.79l-1.63,17.21a2.72,2.72,0,0,0,0,.57,12.26,12.26,0,0,0-1.3.67l-.94-5.89a3.1,3.1,0,0,0-3.54-2.57l-1.56.25a3.09,3.09,0,0,0-2.57,3.54l2.13,13.42a14.08,14.08,0,1,0,27.22-.45,3.05,3.05,0,0,0,.52-1.21Z",
    transform: "translate(-190.9 -558.44)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 240.54,
    cy: 72.79,
    r: 17.96
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M433.19,613.28h-2.6l-4.76.9,2.28-6a2.49,2.49,0,0,1,2.48-2.49h2.6a2.49,2.49,0,0,1,2.48,2.49l1.72,5.38Z",
    transform: "translate(-190.9 -558.44)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M444.78,618l-1.92-1.74-4.14-2.54,5.71-2.89a2.48,2.48,0,0,1,3.51-.18l1.92,1.75a2.48,2.48,0,0,1,.17,3.51L447.69,621Z",
    transform: "translate(-190.9 -558.44)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M450.26,629.69l-.3-2.58-1.44-4.63,6.2,1.58a2.47,2.47,0,0,1,2.75,2.18l.3,2.58a2.48,2.48,0,0,1-2.18,2.75l-5.16,2.32Z",
    transform: "translate(-190.9 -558.44)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.71,641.78l1.55-2.08c.71-1.45,1.41-2.91,2.12-4.36l3.44,5.4a2.48,2.48,0,0,1,.51,3.47l-1.55,2.09a2.49,2.49,0,0,1-3.48.51L444,645Z",
    transform: "translate(-190.9 -558.44)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M436.29,649.48l2.45-.86,4.19-2.45-.15,6.4a2.48,2.48,0,0,1-1.51,3.17l-2.45.87a2.48,2.48,0,0,1-3.17-1.51l-3.42-4.5Z",
    transform: "translate(-190.9 -558.44)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M423.56,647.84l2.31,1.17,4.66,1.36-4.75,4.3a2.48,2.48,0,0,1-3.33,1.09l-2.32-1.18a2.49,2.49,0,0,1-1.09-3.34l.91-5.58Z",
    transform: "translate(-190.9 -558.44)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.49,639.86l1.32,2.24,3.21,3.64-6.31,1.08a2.49,2.49,0,0,1-3.4-.86L408,643.72a2.48,2.48,0,0,1,.87-3.4l3.76-4.22Z",
    transform: "translate(-190.9 -558.44)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M413,626.72l-.27,2.58c.14,1.61.27,3.22.4,4.83l-5.71-2.88a2.5,2.5,0,0,1-2.21-2.73l.27-2.58a2.48,2.48,0,0,1,2.72-2.22l5.54-1.15Z",
    transform: "translate(-190.9 -558.44)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.5,615.75l-1.89,1.78-2.88,3.91q-1.2-3-2.41-5.93a2.49,2.49,0,0,1,.12-3.51l1.9-1.78a2.48,2.48,0,0,1,3.51.13l4.93,2.76Z",
    transform: "translate(-190.9 -558.44)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 578.73,
    y: 633.96,
    width: 15.78,
    height: 34.4,
    rx: 6.43,
    transform: "translate(-255.44 679.33) rotate(-90)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 455.48,
    y: 767.25,
    width: 19.41,
    height: 42.33,
    rx: 6.43,
    transform: "translate(-514.12 695.16) rotate(-90)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,720.25c-4.32-7.39-6.15-18.53-1.05-21.43,4.09-2.32,11.75,1.2,16.31,6.56,4.87,5.71,3.28,10.1,9.17,18.81,5.22,7.71,10.07,9.61,10,11.33C234.42,739.4,209.64,736.72,200,720.25Z",
    transform: "translate(-190.9 -558.44)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.47,695.18c.65,1.72,1.48,3.91.25,5.64-1.5,2.12-5.16,2.17-8.46,2.22s-6,.08-7.54-1.52c-2.21-2.24-.82-6-.32-7.29.26-.67,2.75-7.05,7.59-7.19C562.33,686.89,565.2,694.48,565.47,695.18Z",
    transform: "translate(-190.9 -558.44)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.39,719.05a13.92,13.92,0,0,1,1.08,8.56,22.9,22.9,0,0,1-29.75-.61,14.49,14.49,0,0,1,1.21-7.09c1.84-4.09,6.74-9.74,14.11-9.65C563.57,710.33,568.39,714.88,570.39,719.05Z",
    transform: "translate(-190.9 -558.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.b3fa8a5c279c4f864aafb253358a0b80.svg";
export { ForwardRef as ReactComponent };